import Navbar from "./components/Navbar";
import AppSnakeBar  from "./utils/AppSnakeBar";
import MobileFabMenu from "./components/MobileFabMenu";
import AppRoutes from "./routes/AppRoutes";


function App() {

  return (
    <>
    <Navbar/>
    <MobileFabMenu/>
   <AppSnakeBar/>
    <br/>
   
    <AppRoutes/>
    </>
  );
}

export default App;
